import { createTheme } from "@mui/material";



const theme =(mode)=> createTheme({
    mode,
    palette: {
      primary: {
        light: 'rgb(255, 221, 214)',
        main: 'rgb(255, 78, 35)',   
      },
      secondary: {
        light: 'rgb(229, 254, 240)',
        main: 'rgb(54, 182, 121)',    
      },
      tertiary: {
        light: 'rgb(224, 249, 254)',
        main: 'rgb(206, 29, 255)',    
      },
      quaternary: {
        light: 'rgb(245, 217, 255)',
        main: 'rgb(68, 207, 236)',   
      },
      shade:{
        light: 'rgb(142, 142, 142)',
        main: 'rgb(62, 68, 82)',
        dark:"rgb(229, 236, 244)"
      },
      background: {
        default: mode === 'dark' ? '#000000' : '#ffffff'
      },
      text: {
        primary: mode === 'dark' ? '#ffffff' : '#000000',
      },
    },
    typography: {
      h1: {
        fontSize: '1rem', 
        '@media (max-width:600px)': { 
          fontSize: '1.5rem',
        },
        '@media (min-width:600px)': { 
          fontSize: '2rem',
        },
        '@media (min-width:1000px)': { 
          fontSize: '3rem',
        },
      },
      h4: {
        fontSize: '1.5rem', 
        '@media (max-width:600px)': { 
          fontSize: '1.3rem',
        },
        '@media (min-width:600px)': { 
          fontSize: '1.5rem',
        },
        '@media (min-width:1000px)': { 
          fontSize: '1.7rem',
        },
      },
      h6: {
        fontSize: '1.2rem', 
        '@media (max-width:600px)': { 
          fontSize: '1.2rem',
        },
        '@media (min-width:600px)': { 
          fontSize: '1.3rem',
        },
        '@media (min-width:1000px)': { 
          fontSize: '1.4rem',
        },
      },
    }
  });

  export default theme;